import { Box, Typography } from "@mui/material";
import BuildIcon from '@mui/icons-material/Build';

export default function ErrorScreen() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100%"
      sx={{
        p: 4,
        boxSizing: 'border-box',
        textAlign: 'center',
      }}
    >
      <BuildIcon style={{ fontSize: 60, color: 'grey' }} />
      <Typography variant="h6" component="h3" gutterBottom>
        Sorry! Something went wrong!
      </Typography>
    </Box>
  );
}
